module.exports = "<div class=\"listItem\" *ngFor=\"let cat of this.model\">\r\n    <app-category [model]=\"cat\" (selected)=\"this.selected($event)\" [cascadeSelected]=\"this.cascadeSelected\"></app-category>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/resources/components/category-selection/category-selection.container.component.html
// module id = ./src/app/resources/components/category-selection/category-selection.container.component.html
// module chunks = main